export default {
  getSchedule: {
    url: '/api/daka/getSchedule',
    method: 'get'
  },
  daka: {
    url: '/api/daka/daka',
    method: 'post'
  },
  getClerk: {
    url: '/api/daka/getClerk',
    method: 'get'
  },
  getToday: {
    url: '/api/daka/getToday',
    method: 'get'
  }
}



// WEBPACK FOOTER //
// ./src/api/daka.js